import React, { useState, useEffect } from "react";
import OrderListElement from "./OrderListElement";
import { arrayMove, SortableContainer } from "react-sortable-hoc";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";

export default function OrderSection({ options, onSort }) {
  const itemlist = [...options];
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));

  const OrderList = SortableContainer(({ items }) => {
    return (
      <div className="w-100">
        {items.map((item, index) => {
          return (
            <OrderListElement
              text={item}
              index={index}
              id={itemlist.indexOf(item)}
              key={index}
            />
          );
        })}
      </div>
    );
  });
  const [items, setItems] = useState(options);
  useEffect(() => {
    onSort(items);
  }, [items]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (soudMuted) {
      TickAudio.play();
    }
    setItems(arrayMove(items, oldIndex, newIndex));
  };
  return <OrderList items={items} onSortEnd={onSortEnd} />;
}
